import mapper from 'utils/simple-mapper'

const mapping = [
  ['id'],
  ['sponsorFullName'],
  ['email'],
  ['website'],
  ['logo'],
  ['sponsorLimit'],
  ['status'],
  ['taxId'],
  ['active'],
  ['marketingPromotion'],
]

export const toSponsorModel = (form) => {
  const { status, ...formDTO } = mapper(form, mapping)
  if (status === null) return formDTO
  return { status, ...formDTO }
}
